import React, { useState, useCallback } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Carousel from "react-bootstrap/Carousel";
import { CgWebsite } from "react-icons/cg";
import { BsGithub, BsChevronLeft, BsChevronRight, BsImage } from "react-icons/bs";
import { SiExpress, SiPrisma } from "react-icons/si";
import { FaLock, FaCloud } from "react-icons/fa";

import angularSvg from "../../Assets/TechIcons/angular.svg";
import typescriptSvg from "../../Assets/TechIcons/typescript.svg";
import bootstrapSvg from "../../Assets/TechIcons/bootstrap.svg";
import djangoSvg from "../../Assets/TechIcons/django.svg";
import mysqlSvg from "../../Assets/TechIcons/mysql.svg";
import pythonSvg from "../../Assets/TechIcons/python.svg";
import androidSvg from "../../Assets/TechIcons/android.svg";
import javaSvg from "../../Assets/TechIcons/java.svg";
import postgresqlSvg from "../../Assets/TechIcons/SQL.svg";
import nextjsSvg from "../../Assets/TechIcons/Next.svg";

const iconMap = {
  Angular: { type: "svg", src: angularSvg },
  TypeScript: { type: "svg", src: typescriptSvg },
  Bootstrap: { type: "svg", src: bootstrapSvg },
  Django: { type: "svg", src: djangoSvg },
  MySQL: { type: "svg", src: mysqlSvg },
  Python: { type: "svg", src: pythonSvg },
  Android: { type: "svg", src: androidSvg },
  Java: { type: "svg", src: javaSvg },
  PostgreSQL: { type: "svg", src: postgresqlSvg },
  "Next.js": { type: "svg", src: nextjsSvg },
  Express: { type: "icon", component: SiExpress, color: "#ffffff" },
  Prisma: { type: "icon", component: SiPrisma, color: "#667C9A" },
  Cloudinary: { type: "icon", component: FaCloud, color: "#3448C5" },
  JWT: { type: "icon", component: FaLock, color: "#ffffff" },
};

function ProjectCards(props) {
  const [show, setShow] = useState(false);
  const [loadedImages, setLoadedImages] = useState({});

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleImageLoad = useCallback((index) => {
    setLoadedImages((prev) => ({ ...prev, [index]: true }));
  }, []);

  const desc = props.summary || props.description;
  const techs = props.techs
    ? props.techs.map((t) => ({
        ...(iconMap[t] || { type: "icon", color: "#c9d1d9" }),
        label: t,
      }))
    : [];

  return (
    <>
      <Card className="project-card-view">
        <Carousel 
          indicators={false} 
          controls={props.images && props.images.length > 1}
          prevIcon={<BsChevronLeft color="white" size={30} />}
          nextIcon={<BsChevronRight color="white" size={30} />}
        >
          {(props.images || [null]).map((img, i) => (
            <Carousel.Item key={i}>
              <div style={{ position: "relative", background: "#161b22" }}>
                {!loadedImages[i] && (
                  <div className="project-card-img-placeholder" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <BsImage size={32} color="#30363d" />
                  </div>
                )}
                <Card.Img
                  variant="top"
                  src={img}
                  alt="card-img"
                  onLoad={() => handleImageLoad(i)}
                  style={{ display: loadedImages[i] ? "block" : "none", objectFit: "cover" }}
                />
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
        <Card.Body>
          <Card.Title>{props.title}</Card.Title>
          <Card.Text style={{ textAlign: "justify" }}>
            {desc}
          </Card.Text>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: "16px" }}>
            {techs.map((t, i) => (
              <span key={i} style={{ display: "flex", alignItems: "center", gap: "4px", backgroundColor: "#21262d", padding: "4px 10px", borderRadius: "16px", fontSize: "0.8em", color: "#c9d1d9" }}>
                {t.type === "svg" ? (
                  <img src={t.src} alt={t.label} style={{ height: "14px", width: "14px" }} />
                ) : (
                  <t.component size={14} style={{ fill: t.color, color: t.color }} />
                )} {t.label}
              </span>
            ))}
          </div>
          <div style={{ display: "flex", gap: "10px", marginTop: "auto", flexWrap: "wrap" }}>
            {props.ghLink && (
              <Button variant="primary" href={props.ghLink} target="_blank">
                <BsGithub /> &nbsp;GitHub
              </Button>
            )}
            {!props.isBlog && props.demoLink && (
              <Button variant="primary" href={props.demoLink} target="_blank">
                <CgWebsite /> &nbsp;Demo
              </Button>
            )}
            <Button variant="primary" onClick={handleShow}>
              Ver detalles
            </Button>
          </div>
        </Card.Body>
      </Card>

      <Modal show={show} onHide={handleClose} centered scrollable size="lg" contentClassName="github-modal">
        <Modal.Header closeButton className="github-modal-header">
          <Modal.Title className="github-modal-title">{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="github-modal-body">
          <Carousel 
            indicators={props.images && props.images.length > 1}
            controls={props.images && props.images.length > 1} 
            interval={null}
            prevIcon={<BsChevronLeft color="white" size={40} />}
            nextIcon={<BsChevronRight color="white" size={40} />}
          >
            {(props.images || [null]).map((img, i) => (
              <Carousel.Item key={i}>
                <div style={{ position: "relative", width: "100%", background: "#0d1117", borderRadius: "8px", overflow: "hidden" }}>
                  {!loadedImages[i] && (
                    <div className="github-modal-img-placeholder" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <BsImage size={48} color="#30363d" />
                    </div>
                  )}
                  <img
                    src={img}
                    alt={`slide-${i}`}
                    className="d-block w-100"
                    onLoad={() => handleImageLoad(i)}
                    style={{ display: loadedImages[i] ? "block" : "none", objectFit: "contain", borderRadius: "8px" }}
                  />
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
          <div style={{ marginTop: "20px" }}>
            {props.description.split("\n").map((line, i) => {
              if (line.startsWith("•")) {
                return (
                  <p key={i} style={{ marginBottom: "8px", paddingLeft: "1.2em", textIndent: "-1.2em" }}>
                    {line}
                  </p>
                );
              }
              return <p key={i} style={{ marginBottom: "10px" }}>{line}</p>;
            })}
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "20px", marginBottom: "20px" }}>
            {techs.map((t, i) => (
              <span key={i} style={{ display: "flex", alignItems: "center", gap: "6px", backgroundColor: "#21262d", padding: "6px 14px", borderRadius: "20px", fontSize: "0.9em", color: "#c9d1d9" }}>
                {t.type === "svg" ? (
                  <img src={t.src} alt={t.label} style={{ height: "18px", width: "18px" }} />
                ) : (
                  <t.component size={18} style={{ fill: t.color, color: t.color }} />
                )} {t.label}
              </span>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer className="github-modal-footer">
          {props.ghLink && (
            <Button variant="primary" href={props.ghLink} target="_blank">
              <BsGithub /> GitHub
            </Button>
          )}
          {!props.isBlog && props.demoLink && (
            <Button variant="primary" href={props.demoLink} target="_blank">
              <CgWebsite /> Demo
            </Button>
          )}
          <Button variant="secondary" onClick={handleClose} className="github-modal-close">
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ProjectCards;
